import React, { useState, useContext } from 'react';
import SellerPageHeader from '../../components/SellerPageHeader';
import SellerPageFilterBar from '../../components/SellerPageFilterBar';
import SellerPageCustomerManageBlock1 from "../../components/SellerPageCustomerManageBlock1";
import SellerPageCustomerManageBlock2 from "../../components/SellerPageCustomerManageBlock2";
import ProductListBlock from "../../components/ProductListBlock";
import SellerDiscountBlock from "../../components/SellerDiscountBlock";
import Footer from "../../components/HomePageFooter";
import { NavigationContext } from "../../context/navigation";
import styles from "./sellerpage.module.css";
import 'bootstrap/dist/css/bootstrap.min.css';

function SellerPage() {
  const { open } = useContext(NavigationContext);

  return (
    <div className="SellerPage">
      <SellerPageHeader />
      <div>
        <div className="row">
          <div className="col-md-2">
            <SellerPageFilterBar />
          </div>
          <div className="col-md-10">
            {open.isProducts && <ProductListBlock />}
            {open.isDiscount && <SellerDiscountBlock />}
            {open.isCustomers && <SellerPageCustomerManageBlock1 />}
            {open.isCustomers && <SellerPageCustomerManageBlock2 />}
            { !open.isProducts && !open.isDiscount && !open.isCustomers && <ProductListBlock />}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default SellerPage;
